import axios from 'axios';
import config from '../config';
import {createAuth} from "../Helpers";


const VIDEO_GET_RESPONSE = 'VIDEO_GET_RESPONSE';

const initialState = {
    videos: {}
};

export const actionCreators = {
    getVideoFrame: (id) => async(dispatch, getState) => {
        axios({
            method: 'GET',
            url: `${config.server}/api/video/${id}`,
            withCredentials: true,
            auth: createAuth(getState)
        }).then(response => {
            const data = response.data;
            dispatch({type: VIDEO_GET_RESPONSE, data: data});
        }).catch(error =>{

        });
    }
};

const reducerMethods = {
    VIDEO_GET_RESPONSE: (state, action) => {
        return{
            ...state,
            videos:{
                ...state.videos,
                [action.data.id]: action.data,
            }
        }
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    const method = reducerMethods[action.type];
    if (method) return method(state, action);
    return state;
};